import React from 'react';
import EventCard from '../EventCard';
import type { EventData } from '../../types/events';

const MUSEUM_EVENTS: EventData[] = [
  {
    id: 'museum-fri-11',
    venue: 'museum',
    venueName: 'Club Museum',
    title: '🏛️ RAKKATTA',
    subtitle: 'Nico Maulen - Set Live 🎧🔥',
    date: '2026-09-11',
    dateLabel: '11/09',
    dayLabel: 'Viernes',
    gradientClass: 'gradient-museum-fri',
    accentColor: '#6644ff',
    borderColor: 'rgba(102, 68, 255, 0.6)',
    glowColor: 'rgba(102, 68, 255, 0.35)',
  },
  {
    id: 'museum-sat-12',
    venue: 'museum',
    venueName: 'Club Museum',
    title: '🏛️ MUSEUM',
    subtitle: 'Noche de Nuvo 4x3 🍾✨',
    date: '2026-09-12',
    dateLabel: '12/09',
    dayLabel: 'Sábado',
    gradientClass: 'gradient-museum-sat',
    accentColor: '#ff2060',
    borderColor: 'rgba(255, 32, 96, 0.6)',
    glowColor: 'rgba(255, 32, 96, 0.35)',
  },
  {
    id: 'museum-fri-18',
    venue: 'museum',
    venueName: 'Club Museum',
    title: '🏛️ RAKKATTA',
    subtitle: 'Spring Break Party 🌸🍹',
    date: '2026-09-18',
    dateLabel: '18/09',
    dayLabel: 'Viernes',
    gradientClass: 'gradient-spring-break',
    accentColor: '#00ffaa',
    borderColor: 'rgba(0, 255, 170, 0.6)',
    glowColor: 'rgba(0, 255, 170, 0.35)',
  },
  {
    id: 'museum-sat-19',
    venue: 'museum',
    venueName: 'Club Museum',
    title: '🏛️ MUSEUM',
    subtitle: 'Primavera Encantada ✨🌺',
    date: '2026-09-19',
    dateLabel: '19/09',
    dayLabel: 'Sábado',
    gradientClass: 'gradient-primavera',
    accentColor: '#ffaa00',
    borderColor: 'rgba(255, 170, 0, 0.6)',
    glowColor: 'rgba(255, 170, 0, 0.35)',
  },
  {
    id: 'museum-fri-25',
    venue: 'museum',
    venueName: 'Club Museum',
    title: '🏛️ RAKKATTA',
    subtitle: 'Nacho Serra B2B Nico Servidio 🎧⚔️',
    date: '2026-09-25',
    dateLabel: '25/09',
    dayLabel: 'Viernes',
    gradientClass: 'gradient-nacho',
    accentColor: '#cc00ff',
    borderColor: 'rgba(204, 0, 255, 0.6)',
    glowColor: 'rgba(204, 0, 255, 0.35)',
  },
  {
    id: 'museum-sat-26',
    venue: 'museum',
    venueName: 'Club Museum',
    title: '🏛️ MUSEUM',
    subtitle: 'Show en vivo de Marka Akme 🎤🔥',
    date: '2026-09-26',
    dateLabel: '26/09',
    dayLabel: 'Sábado',
    gradientClass: 'gradient-marka',
    accentColor: '#00ccff',
    borderColor: 'rgba(0, 204, 255, 0.5)',
    glowColor: 'rgba(0, 204, 255, 0.3)',
  },
];

interface ClubMuseumTabProps {
  openListaFree: (event: EventData) => void;
}

export default function ClubMuseumTab({ openListaFree }: ClubMuseumTabProps) {
  return (
    <div className="animate-fade-in">
      {/* Neon Venue Header */}
      <div className="mb-6 text-center px-2">
        <h2
          className="text-5xl sm:text-6xl font-black tracking-tight uppercase leading-none"
          style={{
            color: '#fff',
            textShadow: '0 0 20px #fff, 0 0 50px rgba(255,255,255,0.6), 0 0 80px rgba(102,68,255,0.4)',
          }}
        >
          CLUB MUSEUM
        </h2>
        <p
          className="text-xl sm:text-2xl font-black tracking-[0.35em] uppercase mt-1"
          style={{
            color: '#38bdf8',
            textShadow: '0 0 14px #38bdf8, 0 0 30px rgba(56,189,248,0.7), 0 0 50px rgba(56,189,248,0.4)',
          }}
        >
          BUENOS AIRES
        </p>
        <div
          className="my-4 h-px w-full"
          style={{
            background: 'linear-gradient(90deg, transparent, #6644ff, #ff2060, #cc00ff, #6644ff, transparent)',
            boxShadow: '0 0 10px rgba(102,68,255,0.8), 0 0 20px rgba(255,32,96,0.5)',
          }}
        />
        <p
          className="text-sm sm:text-base font-extrabold tracking-widest uppercase"
          style={{ color: '#cc00ff', textShadow: '0 0 12px #cc00ff, 0 0 24px rgba(204,0,255,0.6)' }}
        >
          LINE UP SEPTIEMBRE #2026
        </p>
        <p className="text-xs sm:text-sm text-muted-foreground mt-1 font-medium">
          PRÓXIMAS FECHAS – TOCÁ UNA PARA ANOTARTE O RESERVAR
        </p>
      </div>

      {/* Event List */}
      <div className="flex flex-col gap-3">
        {MUSEUM_EVENTS.map((event) => (
          <EventCard key={event.id} event={event} onListaFree={openListaFree} />
        ))}
      </div>
    </div>
  );
}